export default (query, tags) => ({
  type: "FAVORITE/QUERY",
  payload: { query, tags }
});
